import axios from 'axios';
import { WhaleSpaceError } from '../errors';
import qs from 'qs';
import { getQSObject } from '../utils/qsUtils';

function errorHandler(error) {
  if (error.isAxiosError && error.response) {
    throw new WhaleSpaceError(error.response.statusText, error.response.status);
  } else {
    throw new WhaleSpaceError(error.message);
  }
}

// const WhaleSpaceBase = '/api/whaleSpace';
const WhaleSpaceBase = '/api/v1/auth/whaleSpace';

const WSApi = axios.create({
  baseURL: WhaleSpaceBase,
  paramsSerializer: (params) => {
    return qs.stringify(params);
  }
});

export async function getWhaleSpaceTokenInfo() {
  try {
    const res = await WSApi.post('/requestTokenInfo');
    return res.data;
  } catch (error) {
    errorHandler(error);
  }
}

export async function reauthorizationWhaleSpace(isSelf = true) {
  const query = getQSObject() || {};
  query['redirect_path'] = location.pathname;
  const redirectURL = `${WhaleSpaceBase}/reAuthorization${qs.stringify(query, {
    encode: true,
    addQueryPrefix: true
  })}`;
  if (isSelf) location.href = redirectURL;
  else window.open(redirectURL, '_blank');
}

export async function requestWhaleSpaceLogout() {
  try {
    await WSApi.delete('/requestLogout');
    return true;
  } catch (error) {
    errorHandler(error);
  }
}

export async function requestUploadIttFile(file, ntt, user) {
  try {
    const bodyFormData = new FormData();
    bodyFormData.append('doc', file);
    bodyFormData.append('ntt', ntt);
    bodyFormData.append('user', user);

    const res = await axios({
      url: `/api/itt/uploadDocument`,
      data: bodyFormData,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    // console.log(
    //   `${res.data.fileName} : https://vf-edu.polarisoffice.com/whale-space/hwp/openDocFromItt?url=${res.data.path}`
    // );
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
}
